import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LoginService } from "./../../../services/login.service";

@Component({
  selector: 'app-toolbar-cliente',
  templateUrl: './toolbar-cliente.component.html',
  styleUrls: ['./toolbar-cliente.component.scss']
})
export class ToolbarClienteComponent implements OnInit {
  public id: any;
  public params?: any 

  constructor(private route: ActivatedRoute, private loginService: LoginService) { 
    /* this.route.params.subscribe( params => this.id=(params['id']));
    console.log(this.id) */
  }

  ngOnInit(): void {
  }

  removeUserStorage(){
    this.loginService.removeUserStorage();
  }

}
